import React, { useContext, useState, useCallback } from 'react'
import { store } from '../../../context/StateProvider'
import CommonService from '../../../services/api/common.service'
import { debounce } from 'lodash'
import AsyncSelect from 'react-select/async'
import moment from "moment";
import Utilities from '../../../services/commonservice/utilities'
import ModalBox from './ModalBox'
import AddPatient from '../../secure/provider/patient/add-patient/AddPatient'
const PatientSelector = (props) => {
    // Context items
    const stateAndDispatch = useContext(store)
    const state = stateAndDispatch.state
    const [patientId, setPatientId] = useState()
    const [showAdd, setShowAdd] = useState(false)

    const patientLoad = (inputText, callBack) => {
        if (inputText?.length < 3) return;
        let reqObj = {
            SearchTerm: inputText,
            isActive: true,
            isRegistered: true,
            SortField: 'lastName',
            SortField2: 'firstName',
            Asc: true,
            Asc2: true
        }
        CommonService.patientLookup(reqObj)
            .then(res => {
                if (res) {
                    callBack(res.data)
                }
            }
            )
            .catch(err => console.log(err))
    }

    const rePatientLoad = useCallback(debounce(patientLoad, 500), [])

    const setCurrentPatient = async (newPatientId) => {
        setPatientId(newPatientId);
        if (props.onChanging) props.onChanging(newPatientId)
        if (props.onSelected) props.onSelected(newPatientId)
    }

    return (
        <>
            <AsyncSelect
                classNamePrefix="react-select"
                className="react-select-container"
                name="patientId"
                loadOptions={rePatientLoad}
                placeholder="Search Patient"
                onChange={e => {
                    if (e?.id) {
                        setCurrentPatient(e.id)
                    }
                    else {
                        setCurrentPatient(null)
                    }
                }}
                isClearable={true}
                formatOptionLabel={(option, { context }) => {
                    if (context === "menu") {
                        // Dropdown View
                        return (
                            <div className="d-flex row">
                                <span className="col">{option.firstName} {option.lastName}</span>
                                <span className="col text-start">
                                    <i className="icon birthday cake" /> {moment.utc(option.dob).format("M/D/YYYY")}
                                </span>
                                <span className="col text-end">
                                    {option.mobile || option.patientPhone ? (
                                        <>
                                            <i className="icon phone" />
                                            {Utilities.toPhoneNumber(option.mobile || option.patientPhone)}
                                        </>
                                    ) : null}
                                </span>
                            </div>
                        );
                    } else {
                        // Selected View
                        return (
                            <div style={{
                                display: 'flex'
                            }}>
                                <span style={{ marginRight: '8px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {option.firstName} {option.lastName}
                                </span>
                                <i className='icon birthday cake' style={{ marginRight: '4px' }} />
                                <span style={{ marginRight: '8px' }}>
                                    {moment.utc(option.dob).format("M/D/YYYY")}
                                </span>
                                {(option.mobile || option.patientPhone) && (
                                    <>
                                        <i className='icon phone' style={{ marginRight: '4px' }} />
                                        <span>
                                            {Utilities.toPhoneNumber(option.mobile || option.patientPhone)}
                                        </span>
                                    </>
                                )}
                            </div>
                        );
                    }
                }}
                getOptionValue={(option) => option.id}
                noOptionsMessage={(e) => {
                    //pass showAddPatient to show add patient button
                    if (!state.permissions.patientModifyPatients || !props?.showAddPatient) {
                        return null;
                      } else {
                        return (
                          <button
                            className='btn btn-primary form-control'
                            onClick={(e) => {
                              e.preventDefault();
                              setShowAdd(true);
                            }}
                          >
                            Add Patient
                          </button>
                        );
                      }
                }}
            />
            <ModalBox open={showAdd} onClose={() => { setShowAdd(false) }} title="Register Patient">
                <AddPatient onClose={() => { setShowAdd(false) }} />
            </ModalBox>
        </>

    )
}
export default PatientSelector